import { useSuspenseQuery } from '@tanstack/react-query';

import { GerProfileActivitySummaryApiResponse } from '@/entities/profile';
import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

const fetchProfileActivitySummary = async () => {
  const { data } = await clientAxios.get<
    ApiResponse<GerProfileActivitySummaryApiResponse>
  >('/getProfileActivitySummaryApi/');

  const {
    read_count,
    scrapped_count,
    collection_activity_count,
    highlight_count,
  } = data.data;

  return {
    view: read_count,
    scrap: scrapped_count,
    collection: collection_activity_count,
    highlight: highlight_count,
  };
};

export const useProfileActivitySummary = () => {
  const query = useSuspenseQuery({
    queryKey: ['getProfileActivitySummaryApi'],
    queryFn: fetchProfileActivitySummary,
  });

  return query;
};
